import { InputNumber, Select, type InputNumberProps } from "antd";
import { ReactComponent as ArrowDropUpIcon } from "../../../../assets/images/arrow-drop-up-16.svg";
import { ReactComponent as ArrowDropDownIcon } from "../../../../assets/images/arrow-drop-down-16.svg";
import styles from "./style.module.less";

export const SEED_RATE_CONTROLS = {
  upIcon: <ArrowDropUpIcon aria-hidden />,
  downIcon: <ArrowDropDownIcon aria-hidden />,
};

interface SeedRateInputProps
  extends Pick<
    InputNumberProps<number>,
    | "value"
    | "onChange"
    | "status"
    | "disabled"
    | "readOnly"
    | "controls"
    | "aria-label"
    | "aria-invalid"
    | "aria-describedby"
  > {
  options?: number[];
}

const SeedRateInput = ({
  options = [],
  disabled,
  readOnly,
  controls = true,
  ...props
}: SeedRateInputProps): JSX.Element =>
  options.length > 0 ? (
    <Select<number>
      {...props}
      className={styles.select}
      value={props.value ?? undefined}
      options={options.map((rate) => ({ label: String(rate), value: rate }))}
      disabled={readOnly === true ? true : disabled}
      onChange={(rate) => props.onChange?.(rate)}
    />
  ) : (
    <InputNumber<number>
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      controls={controls}
    />
  );

export default SeedRateInput;
